export default [
  {
    add_more_items: "Tilføj flere varer",
    already_have_account: "Har du allerede en konto? Log på",
    as_soon: "Hurtigst muligt",
    as_soon_description:
      "Din ordre forventes leveret om %{etimateTime} minutter",
    cart_items: "Din bestilling",
    cash: "Kontanter",
    checkout: "Gennemfør bestilling",
    checkout_extra_bag_cost: "Lovpligtig bæreposeafgift",
    serviceFee: "Håndterings gebyr",
    checkout_extra_bag_cost_description:
      "Folketinget har ændret miljøbeskyttelsesloven, hvormed det fra 1. januar 2021 er forbudt at uddele gratis bæreposer med hank",
    checkout_processing: "Din bestilling behandles",
    choose_payment_method: "Vælg betalingsmetode",
    comment_restaurant: "Kommentar til restauranten",
    confirm_order: "Bekræft ordre",
    Delivery: "Levering",
    delivery_adders_out_range: "Adressen er uden for leveringsområdet.",
    Delivery_description:
      "Jeg har brug for en hurtig person til at leverer min ordre",
    Delivery_description_checkout: "Levering %{date} kl. %{time} til %{where} ",
    Delivery_description_checkout_asap:
      "Levering til %{where} %{buildingNo}, %{city} ",
    delivery_distance: "Leveringsafstand",
    delivery_method_time: "Leveringsmetode og tid",
    delivery_to: "Levering til %{street}",
    guest: "Dine oplysninger",
    guest_info: "Dine oplysninger",
    how_question: "Hvordan ?",
    min_delivery: "Minimum for levering er : %{amount}",
    min_pickup: "Minimum for afhentning er : %{amount}",
    no_available: "Ingen mulighed for tid. Kontakt support",
    no_contact_delivery: "Kontaktløs levering",
    no_contact_delivery_description: "Lad venligst ordren ligge foran min dør",
    no_etimated: "Beregner tid",
    "online-payment": "Online betaling",
    order_details: "Ordre detaljer",
    payment: "Betaling",
    payment_details: "Betalingsoplysninger",
    Pickup: "Afhentning",
    Pickup_description: "Jeg afhenter selv ordren",
    prices_include_vat: "Priserne er inklusiv moms",
    schedule: "Forudbestilling",
    schedule_date_time: "Du modtager din ordre: %{date} kl. %{time}",
    schedule_description: "Forudbestilling til senere",
    select_order_details: "Leveringsmetode & tid",
    selected_items: "Din bestilling",
    some_address: "Vi skal bruge en adresse",
    subtotal: "Subtotal",
    total: "Total",
    we_need_delivery_address: "Du mangler at angive en addresse til levering",
    we_need_fill_payment: "Du mangler at vælge en betalingsmetode",
    we_need_some_info_about_you:
      "Du mangler at oplyse hvem bestillingen er til",
    we_need_when_option: "Du mangler at vælge tidspunkt",
    AddressDeliveryZone: "Adressen er udenfor vores leveringszone",
    AddressScheduleTime:
      "Restauranten har lukket for levering på det valgte tidspunkt",
    AddressDeliveryGeneric: "Noget gik galt, kontakt venligst support",
    we_need_you_do_login: "Du skal logge ind",
    when_question: "Hvornår ?",
    where_question: "Hvor ?",
    confirmOrder: "Bekræft bestilling",
    orderToTable: "Bestilling til bord",
    cardNumber: "Kortnummer",
    cvc: "Sikkerhedskode",
    expDate: "Udlobsdato",
    discountCodeText: "Har du en rabat kode?",
    fpDescription:
      "Når du klikker på 'Gennemfør bestilling', vil du blive omdirigeret til vores sikre betalingsside for at fuldføre dit køb.",
    today: "i dag",
    tomorrow: "i morgen",
    information: "Information",
  },
];
